import { EXPORT_INPUT } from './topics';
import { Joi, actionCreator, literalAs, objectSchemaOf } from '../helpers';

export const TO_BUCKET = 'EXPORT/TO_BUCKET' as const;

export interface IToBucketAction {
  type: typeof TO_BUCKET;
}

export const toBucketActionSchema = objectSchemaOf<IToBucketAction>({
  type: Joi.string().valid(TO_BUCKET).required(),
});

export const toBucket = actionCreator({
  type: TO_BUCKET,
  topic: EXPORT_INPUT,
  schema: toBucketActionSchema,
  creator: () => literalAs<IToBucketAction>({ type: TO_BUCKET }),
});
